export const MIN_PRICE_DIGITS = 0
export const MAX_PRICE_DIGITS = 2
